import { STATUS } from '~/literals';

import { Topic } from '~/types';

export const description = 'A precision typing test — measure WPM, accuracy, and consistency.';
export const name = 'Cryotype';
export const topic: Topic = {
  cached: false,
  data: [],
  message: '',
  status: STATUS.IDLE,
  updatedAt: 0,
};
